
















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Star extends Vue {
  @Prop({ default: '44' }) readonly width?: string;
  @Prop({ default: '42' }) readonly height?: string;
  @Prop({ default: false }) readonly selected?: boolean;
}
